import { Box, Button, Tooltip, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import LoadingButton from '@/components/Buttons/LoadingButton';
import useQuoteIntakeSetupStore from '@/stores/useQuoteIntakeSetupStore';

export default function QuoteIntakeSetupFooter() {
    const [currentStep, setCurrentStep, formData, setFormData, callApi, loading] =
        useQuoteIntakeSetupStore((state) => [
            state.currentStep,
            state.setCurrentStep,
            state.formData,
            state.setFormData,
            state.callApi,
            state.loading,
        ]);
    const navigate = useNavigate();
    const theme = useTheme();

    const handleStepThree = (skip = false) => {
        if (!skip) {
            if (formData.step3.isScreenTwo) {
                callApi('step3', '2');
            } else {
                callApi('step3', '1');
            }
        } else {
            if (formData.step3.isScreenTwo) {
                setCurrentStep(currentStep + 1);
            } else {
                setFormData('step3', {
                    ...formData.step3,
                    isScreenTwo: true,
                });
            }
        }
    };
    const handleStepTwo = async (skip = false) => {
        if (!skip) {
            if (formData.step2.isScreenTwo) {
                try {
                    await callApi('step2', '2');
                    setCurrentStep(currentStep + 1);
                } catch (error) {
                    console.error(error);
                }
            } else {
                try {
                    await callApi('step2', '1');
                } catch (error) {
                    console.error(error);
                }
            }
        } else {
            if (formData.step2.isScreenTwo) {
                setCurrentStep(currentStep + 1);
            } else {
                setFormData('step2', {
                    ...formData.step2,
                    isScreenTwo: true,
                });
            }
        }
    };

    const handleStepFour = async () => {
        if (formData.step4.isScreenTwo) {
            callApi('step4', '2');
        } else {
            callApi('step4', '1');
            setFormData('step4', {
                ...formData.step4,
                isScreenTwo: true,
            });
        }
    };

    const handleStepThreeBack = () => {
        if (formData.step3.isScreenTwo) {
            setFormData('step3', {
                ...formData.step3,
                isScreenTwo: false,
            });
        } else {
            setCurrentStep(currentStep - 1);
        }
    };

    const handleStepTwoBack = () => {
        if (formData.step2.isScreenTwo) {
            setFormData('step2', {
                ...formData.step2,
                isScreenTwo: false,
            });
        } else {
            setCurrentStep(currentStep - 1);
        }
    };

    const handleStepFourBack = () => {
        if (formData.step4.isScreenTwo) {
            setFormData('step4', {
                ...formData.step4,
                isScreenTwo: false,
            });
        } else {
            setCurrentStep(currentStep - 1);
        }
    };

    const handleBack = () => {
        setCurrentStep(currentStep - 1);
    };

    const handleFinish = async (skip = false) => {
        if (!skip) {
            if (formData.step5.isScreenTwo) {
                try {
                    await callApi('step5', '2');
                    navigate('/templates/quotes');
                } catch (error: any) {
                    console.error(error);
                }
            } else {
                try {
                    await callApi('step5', '1');
                } catch (error) {
                    console.error(error);
                }
            }
        } else {
            if (formData.step5.isScreenTwo) {
                navigate('/templates/quotes');
            } else {
                setFormData('step5', {
                    ...formData.step5,
                    isScreenTwo: true,
                });
            }
        }
    };

    const handleStepFiveBack = () => {
        if (formData.step5.isScreenTwo) {
            setFormData('step5', {
                ...formData.step5,
                isScreenTwo: false,
            });
        } else {
            setCurrentStep(currentStep - 1);
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                backgroundColor: '#FFFFFF',
                justifyContent: 'flex-end',
                boxSizing: 'border-box',
                padding: '0 32px',
                borderTop: `1px solid ${theme.palette.neutral.borderColor}`,
            }}
        >
            {currentStep === 0 && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <Tooltip
                        placement="top"
                        title={
                            formData.step0.transactionType === ''
                                ? 'Please select transaction types'
                                : null
                        }
                    >
                        <span>
                            <LoadingButton
                                disabled={
                                    formData.step0.transactionType === '' ||
                                    formData.step0.assignedLawyer === 0 ||
                                    formData.step0.assignedLawyer === undefined ||
                                    formData.step0.templateName === '' ||
                                    formData.step0.province === ''
                                }
                                onClick={() => {
                                    callApi('step0');
                                }}
                                variant="contained"
                                loading={loading}
                            >
                                Next
                            </LoadingButton>
                        </span>
                    </Tooltip>
                </Box>
            )}
            {currentStep === 1 && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <Button onClick={handleBack} variant="outlined">
                        Back
                    </Button>
                    <LoadingButton
                        loading={loading}
                        onClick={() => callApi('step1')}
                        variant="contained"
                    >
                        Next
                    </LoadingButton>
                </Box>
            )}
            {currentStep === 2 && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <Button onClick={handleStepTwoBack} variant="outlined">
                        Back
                    </Button>
                    <LoadingButton
                        onClick={() => handleStepTwo(false)}
                        variant="contained"
                        loading={loading}
                    >
                        Next
                    </LoadingButton>
                </Box>
            )}
            {currentStep === 3 && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <Button onClick={handleStepThreeBack} variant="outlined">
                        Back
                    </Button>
                    <Tooltip placement="top" title={null}>
                        <span>
                            <LoadingButton
                                loading={loading}
                                disabled={formData.step3.pricingModel === ''}
                                onClick={() => handleStepThree(false)}
                                variant="contained"
                            >
                                Next
                            </LoadingButton>
                        </span>
                    </Tooltip>
                </Box>
            )}
            {currentStep === 4 && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <Button onClick={handleStepFourBack} variant="outlined">
                        Back
                    </Button>
                    <LoadingButton
                        loading={loading}
                        disabled={
                            formData.step0.intakeFormAdded === '' ||
                            ((formData.step0.intakeFormAdded === 'Copy' ||
                                formData.step0.intakeFormAdded === 'Reference') &&
                                !formData.step0?.referencedIntakeOnlyQuoteTemplateId)
                        }
                        onClick={handleStepFour}
                        variant="contained"
                    >
                        Next
                    </LoadingButton>
                </Box>
            )}
            {currentStep === 5 && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <Button onClick={handleStepFiveBack} variant="outlined">
                        Back
                    </Button>
                    <LoadingButton
                        variant="contained"
                        onClick={() => handleFinish(false)}
                        loading={loading}
                    >
                        {formData.step5.isScreenTwo ? 'Finish' : 'Next'}
                    </LoadingButton>
                </Box>
            )}
        </Box>
    );
}
